'use client';

import { useState } from 'react';
import { childIds } from './helpers';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

export function MacaronCarousel({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const ids = childIds(config.children);
  const [index, setIndex] = useState(0);
  if (ids.length === 0) return null;
  const safeIndex = Math.max(0, Math.min(index, ids.length - 1));

  return (
    <div className="flex w-full min-w-0 flex-col gap-2">
      <div className="min-w-0 overflow-hidden rounded-xl border border-[#EAECF0] p-2">{ctx.renderChild(ids[safeIndex])}</div>
      {ids.length > 1 ? (
        <div className="flex items-center justify-between">
          <button type="button" className="rounded-md border border-[#D0D5DD] px-2 py-1 text-xs" onClick={() => setIndex((v) => Math.max(0, v - 1))}>
            Prev
          </button>
          <span className="text-xs text-[#667085]">
            {safeIndex + 1} / {ids.length}
          </span>
          <button type="button" className="rounded-md border border-[#D0D5DD] px-2 py-1 text-xs" onClick={() => setIndex((v) => Math.min(ids.length - 1, v + 1))}>
            Next
          </button>
        </div>
      ) : null}
    </div>
  );
}
